import { Fragment, memo } from 'react';
import Shaxmatka2Row from './Shaxmatka2Row';
import HOME_TYPE from 'shared/homeTypeList';
import Shaxmatka2FreeRow from './Shaxmatka2FreeRow';
import { useShowroom } from 'context';

const Shaxmatka2PadezdItem = ({
  block,
  padezdItem,
  padezdIndex,
  blockIndex,
  toggleSelectionItem = () => {},
  settingsMenuValue = '',
  isEditing,
}) => {
  const [{ mode }] = useShowroom();
  const isEditingPlace = mode == 'PLACE_EDIT';
  const getRoomsByStatus = (statusCode) => {
    return padezdItem?.homes.length > 0
      ? padezdItem?.homes?.filter((item) => item.status == statusCode).length
      : 0;
  };

  const getFullFloorsNumberByPadezd = (padezd) => {
    let a = Array.from(new Set(padezd?.homes.map((item) => item?.stage)));
    if (a.includes('-1')) {
      a.push('0');
    }
    a.sort((x, y) => x - y);
    return a.reverse();
  };

  const minStage = Math.min(...padezdItem?.homes?.map((item) => item?.stage));

  return (
    <Fragment>
      <div className={`my-2 mt-0 ml-1 leading-4${!padezdIndex && ' ml-9'}`}>
        <span className='font-medium text-base text-line-1'>
          {padezdItem?.name}
        </span>
        <div className='text-[12px] leading-3 flex items-center'>
          <div className='flex items-center'>
            <div className='w-[14px] h-[14px] rounded-sm mr-1 bg-[var(--shaxmatka-active-home)]'></div>
            {getRoomsByStatus(HOME_TYPE.ACTIVE.code)}
          </div>
          <span className='mx-1 text-gray-500'>|</span>
          <div className='flex items-center'>
            <div className='w-[14px] h-[14px] rounded-sm mr-1 bg-[var(--shaxmatka-ordered-home)]'></div>
            {getRoomsByStatus(HOME_TYPE.TIME.code)}
          </div>
          <span className='mx-1 text-gray-500'>|</span>
          <div className='flex items-center'>
            <div className='w-[14px] h-[14px] rounded-sm mr-1 bg-[var(--shaxmatka-sold-home)]'></div>
            {getRoomsByStatus(HOME_TYPE.ORDERED.code)}
          </div>
          <span className='mx-1 text-gray-500'>|</span>
          <div className='flex items-center'>
            <div className='w-[14px] h-[14px] rounded-sm mr-1 bg-[var(--shaxmatka-disabled-home)]'></div>
            {getRoomsByStatus(HOME_TYPE.DISABLED.code)}
          </div>
        </div>
      </div>
      {isEditingPlace && (
        <div
          className={`sheet-row ${
            padezdIndex != 0 ? '!pl-0' : ''
          } floor-${'top'}`}
          key={`block-${padezdItem?.id}-row-${'top'}`}
          id={`block-${padezdItem?.id}-row-${'top'}`}
        >
          <Shaxmatka2FreeRow
            floorNumber={padezdItem?.max_stage + 1}
            maxPlace={padezdItem?.max_place}
            block_id={padezdItem?.block_id}
            padezd_id={padezdItem?.id}
            padezdIndex={padezdIndex}
          />
        </div>
      )}
      {getFullFloorsNumberByPadezd(padezdItem).map((floorNumber, index) => (
        <div
          className={`sheet-row ${
            padezdIndex != 0 ? '!pl-0' : ''
          } floor-${floorNumber}`}
          key={`block-${padezdItem?.id}-row-${index}`}
          id={`block-${padezdItem?.id}-row-${index}`}
        >
          <Shaxmatka2Row
            block={block}
            homesData={padezdItem?.homes}
            blockIndex={blockIndex}
            padezdIndex={padezdIndex}
            maxPlace={padezdItem?.max_place}
            floorNumber={floorNumber}
            isEditing={isEditing}
            toggleSelectionItem={toggleSelectionItem}
            settingsMenuValue={settingsMenuValue}
            block_id={padezdItem?.block_id}
            padezd_id={padezdItem?.id}
          />
        </div>
      ))}
      {isEditingPlace && (
        <div
          className={`sheet-row ${
            padezdIndex != 0 ? '!pl-0' : ''
          } floor-${'bottom'}`}
          key={`block-${padezdItem?.id}-row-${'bottom'}`}
          id={`block-${padezdItem?.id}-row-${'bottom'}`}
        >
          <Shaxmatka2FreeRow
            floorNumber={minStage == 1 ? -1 : minStage - 1}
            maxPlace={padezdItem?.max_place}
            block_id={padezdItem?.block_id}
            padezd_id={padezdItem?.id}
            padezdIndex={padezdIndex}
          />
        </div>
      )}
    </Fragment>
  );
};

export default memo(Shaxmatka2PadezdItem);
